import { gspx } from '@rsos/gainsight';

const trackCameraEvent = (name, cameraID) => {
  gspx.trackCustomEvent('Ellington', {
    name: name,
    Category: 'Ellington',
    'Launched date': new Date(),
    cameraID: cameraID,
  });
};

export const trackBlurPreview = (isBlurred, cameraID) => {
  const intentOfClick = isBlurred ? 'unblur' : 'blur';

  trackCameraEvent(`Click to ${intentOfClick} stream`, cameraID);
};

export const trackFetchEagleEyeCookie = (isSuccess, cameraID) => {
  const gainsightText = isSuccess ? 'succeeded' : 'failed';

  trackCameraEvent(`Fetch EEN session cookie ${gainsightText}`, cameraID);
};

export const trackFetchEagleEyePreview = (isSuccess, cameraID) => {
  const gainsightText = isSuccess ? 'succeeded' : 'failed';

  trackCameraEvent(`Fetch preview image ${gainsightText}`, cameraID);
};

export const trackVideoPlay = cameraID => {
  trackCameraEvent('Play Eagle Eye Media', cameraID);
};

export const trackVideoPause = cameraID => {
  trackCameraEvent('Pause Eagle Eye Media', cameraID);
};

export const trackVideoLoadedData = cameraID => {
  trackCameraEvent('Loaded Eagle Eye Media Data', cameraID);
};

export const trackVideoLoadStart = cameraID => {
  trackCameraEvent('Load Eagle Eye Media Start', cameraID);
};

export const trackFullscreen = cameraID => {
  trackCameraEvent('Fullscreen Eagle Eye Media', cameraID);
};
